import { useTheme } from '@emotion/react';
import type { FunctionComponent } from 'react';

export const ProgressCircleOutline: FunctionComponent<{
    readonly circleLength: number;
    readonly cx: number | string;
    readonly cy: number | string;
    readonly dashLength: number;
    readonly isActive: boolean;
    readonly radius: number;
    readonly strokeWidth: number;
    readonly transform: string;
}> = ({ circleLength, cx, cy, dashLength, isActive, radius, strokeWidth, transform }) => {
    const theme = useTheme();

    return (
        <circle
            cx={cx}
            cy={cy}
            r={radius}
            stroke={isActive ? theme.colors.orange[800] : theme.colors.white[200]}
            strokeDasharray={`${dashLength} ${circleLength}`}
            strokeLinecap="round"
            strokeWidth={strokeWidth + 2.5}
            transform={transform}
        />
    );
};
